export const ERROR_NAME = 'AuthError'

export class AuthError extends Error {
  constructor(message) {
    super(message || 'unable to authenticate user')
    this.name = ERROR_NAME
  }
}

export default AuthError
